import { render, staticRenderFns } from "./PayGoods.vue?vue&type=template&id=98dc934c&scoped=true"
import script from "./PayGoods.vue?vue&type=script&lang=js"
export * from "./PayGoods.vue?vue&type=script&lang=js"
import style0 from "./PayGoods.vue?vue&type=style&index=0&id=98dc934c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dc934c",
  null
  
)

export default component.exports